module.exports = __webpack_public_path__ + "img/179998.c4c98403.png";